import { createAsyncThunk } from "@reduxjs/toolkit";
import AxiosClient from "../AxiosClient";
import {
  USER_TRANSACTIONS_LIST_PATH,
  buildUserTransactionsListQueryParams,
} from "src/app/pages/pricing-page/userTransactionsListApi";

export type UserTransactionsListRequest = {
  page: number;
  limit?: number;
  sort_by?: string;
  sort_order?: string;
  searchStr?: string;
  chargeYear?: string;
  chargeMonthName?: string;
};

export const getInvoiceDeatilsListAsync = createAsyncThunk(
  'market/getInvoiceDeatilsListAsync',
  async function (
    params: { paramData: UserTransactionsListRequest },
    toolkit
  ) {
    const {
      page,
      limit,
      sort_by,
      sort_order,
      searchStr = '',
      chargeYear = '',
      chargeMonthName = '',
    } = params.paramData

    const queryParams = buildUserTransactionsListQueryParams(
      { searchStr, chargeYear, chargeMonthName },
      { page, limit, sort_by, sort_order }
    )

    return await AxiosClient(
      'GET',
      USER_TRANSACTIONS_LIST_PATH,
      [],
      toolkit,
      queryParams,
      toolkit.signal
    )
  }
)

export const cancelOverageInvoiceAsync = createAsyncThunk(
  'market/cancelOverageInvoiceAsync',
  async function (transactionId: number, toolkit) {
    return await AxiosClient(
      'POST',
      `/api/cancel-overage-invoice/${transactionId}`,
      [],
      toolkit,
      []
    )
  }
)
          
export const downloadInvoiceAsync = createAsyncThunk(
  'market/downloadInvoiceAsync',
  async function (params: { transaction_id: number }, toolkit) {
    try {
      const response = await AxiosClient(
        'GET',
        `/api/invoice-download/${params?.transaction_id}`,
        [],
        toolkit,
        [],
        toolkit.signal,
        'blob'
      );

      // FIX: use response.data for blob
      const blob = new Blob([response.data], { type: "application/pdf" });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `invoice-${params.transaction_id}.pdf`;

      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      return toolkit.fulfillWithValue({ success: true });
    } catch (error) {
      return toolkit.rejectWithValue({ success: false });
    }
  }
);

